import React, { useState, useEffect, useReducer } from "react"
import { connect } from "react-redux"

import { withTranslation } from "react-i18next"
import {
  getGasProjectFiles,
  getGasProjectsFullFilter,
  getListPackageInstaller,
  resetGasProjectFlag,
  resetPackage,
  sendGasProjectToGas,
  submitPackage,
} from "store/actions"
import { getCurrentUser, serializeQuery } from "helpers/service_helper"

import { Table, Pagination, Input, Space, Button, Row, Col, Radio, Divider } from "antd"
import { SearchOutlined } from "@ant-design/icons"
import { projectColumnsAnt } from "./ProjectColumnsAnt"
import { NumericInput } from "components/Common/NumericInput"
const { Search } = Input
const ListGasProject = props => {
  const {
    lstGasProjectsFullFilter,
    lstGasProjectsFullFilterTotal,
    matches_sm,
    loading,
    onGetGasProjectsFullFilter,
    openNotification,
    reload,
    handleChangeExpand,
    userInfo,
    expanded,
  } = props

  const [errorMessage, setErrorMessage] = useState(null)
  const [pageSize, setPageSize] = useState(10)
  const [pageIndex, setPageIndex] = useState(1)
  const [filterCity, setFilterCity] = useState(false)
  const [isFirstRender, setIsFirstRender] = useState(true)

  const [dataAddress, setDataAddress] = useState({
    sectionId: 0,
    fullAddress: {
      pro: "",
      cit: "",
      sec: "",
      lat: 35.311308,
      lng: 46.991271,
      mainAddress: "",
    },
  })
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      fileNumber: null,
      searchValue: "",
      projectLevelEnum: 100,
      isStop: false,
      firstPlanFilter: false,
      isoFilter: false,
      serialNumber: "",
      filterSubmitByInstaller:1
    }
  )
  const handleInput = evt => {
    const name = evt.target.name
    let newValue = evt.target.value
    if (evt.target.type === "checkbox") newValue = evt.target.checked
    setFormInput({ [name]: newValue })
  }



  useEffect(async () => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", props.error)
  }, [errorMessage, props.success, props.error])

  useEffect(async () => {
    await handleSearchGasProject("pageIndex")
  }, [pageIndex, pageSize, formInput.filterSubmitByInstaller])

  useEffect(async () => {
    if (reload) {
      await handleSearchGasProject()
    }
  }, [reload])


  const handleSearchGasProject = async val => {
    let searchQuery = {
      ...formInput,
      page: val === "search" ? 1 : pageIndex,
      pageSize: val === "search" ? 10 : pageSize,
      fileNumber: formInput.fileNumber ? formInput.fileNumber : 0,
      solarRegisterDate: "",
      idSection: filterCity ? +dataAddress?.sectionId : 0,
      cityId: filterCity ? +dataAddress?.cityId : 0,
      exeName: formInput?.exeName ? formInput.exeName : "",
      landLordName: formInput?.landLordName ? formInput.landLordName : "",
      isStop: false,
      firstPlanFilter: false,
      isoFilter: false,
      isFilterSubmitByInstaller: formInput.filterSubmitByInstaller === 0?false:true,
      packageInstallerSubmit: formInput.filterSubmitByInstaller === 2?true:false,
    }
    const params = serializeQuery(searchQuery)
    onGetGasProjectsFullFilter(searchQuery)
  }


  return (
    <>
      <Row gutter={[6, 6]}>
       <Col>
          <Radio.Group
            name="filterSubmitByInstaller"
            onChange={handleInput}
            value={formInput.filterSubmitByInstaller}
          >
            <Space direction={matches_sm ? "vertical" : "horizontal"}>
              <Radio value={1}> انتظار تایید</Radio>
              <Radio value={2}> تایید شده </Radio>
              <Radio value={0}>همه</Radio>
            </Space>
          </Radio.Group>
        </Col>

        {/* <Divider /> */}

        <Col className="gutter-row">
          <NumericInput
            style={{
              width: 150,
            }}
            value={formInput.fileNumber}
            name="fileNumber"
            onChange={handleInput}
            placeholder="شماره پرونده"
          />
        </Col>
        <Col >
          <Input
            name="exeName"
            onChange={handleInput}
            placeholder="مجری"
            allowClear={true}
          />
        </Col> 
        <Col>
          <Input
            name="landLordName"
            onChange={handleInput}
            placeholder="مالک"
            allowClear={true}
          />
        </Col>
        <Col>
          <Input
            name="serialNumber"
            onChange={handleInput}
            placeholder="شماره سریال"
            allowClear={true}
          />
        </Col> 
        <Col className="gutter-row">
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={() => handleSearchGasProject("search")}
          >
            جستجو
          </Button>
        </Col>
      </Row>
      <Divider></Divider>
      <Table
        loading={loading}
        size="small"
        pagination={false}
        scroll={{
          x: matches_sm ? 350 : 700,
        }}
        sticky="true"
        columns={projectColumnsAnt({
          props,
          setErrorMessage,
          currentUser: getCurrentUser(),
          matches_sm,
          pageIndex,
          pageSize,
          userInfo,
          expanded,
          handleChangeExpand,
          projectLevelEnum: 100,
        })}
        rowKey={record => record.id}
        dataSource={lstGasProjectsFullFilter}
      />
      <Pagination
        current={pageIndex}
        className="pt-2 custom-pagination"
        total={lstGasProjectsFullFilterTotal}
        onChange={(page, size) => {
          console.log("page,size", page, size)
          setPageIndex(page)
          setPageSize(size)
        }}
      />
      تعداد کل : {lstGasProjectsFullFilterTotal}
    </>
  )
}

const mapStateToProps = ({
  GasProjects,
  USERs,
  PackageInstaller
}) => ({
  lstGasProjectsFullFilter: GasProjects.lstGasProjectsFullFilter,
  lstGasProjectsFullFilterTotal: GasProjects.lstGasProjectsFullFilterTotal,
  lstGasProjectFiles: GasProjects.lstGasProjectFiles,
  loading: GasProjects.loading,
  error: GasProjects.error,
  success: GasProjects.success,
  userBalance: USERs.userBalance,
  userInfo: USERs.userInfo,
  lstPackageInstaller:PackageInstaller.lstPackageInstaller,
  installerLoading:PackageInstaller.loading,
  reload: GasProjects.triggerReload,
})

const mapDispatchToProps = dispatch => ({
  onGetGasProjectsFullFilter: searchValue => dispatch(getGasProjectsFullFilter(searchValue)),
  onResetGasProjectFlag: () => dispatch(resetGasProjectFlag()),
  onGetProjectFiles: gasProjectId => dispatch(getGasProjectFiles(gasProjectId)),
  onResetPackage: gpId => dispatch(resetPackage(gpId)),
  onSendGasProjectToGas: fileNumber => dispatch(sendGasProjectToGas(fileNumber)),
  onSubmitPackage: attachData => dispatch(submitPackage(attachData)),
  onGetListPackageInstaller: () => dispatch(getListPackageInstaller()),
  
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ListGasProject))
